import Inherit from '../../core/inherit';
import CampaignsDelegate from './campaigns.delegate';
import ShelfController from '../../core/shelf.controller';

class CampaignsController extends Inherit(ShelfController, CampaignsDelegate) {
    async initialize() {
        let campaigns = null;
        let stores = null;
        if (this.isAuthenticated) {
            campaigns = await this.data.fetchCampaigns();
            stores = await this.data.fetchAllStores();

            // Check if we're in edit mode
            const editId = this.props.searchParams?.get('edit');
            if (editId) {
                const campaignToEdit = campaigns.find((c) => c._id === editId);
                if (campaignToEdit) {
                    this.setState({
                        campaigns,
                        rows: campaigns,
                        loading: false,
                        stores,
                        isOpen: true,
                        editMode: true,
                        editingCampaign: campaignToEdit
                    });
                    return;
                }
            }
        } else this.navigateLogin();

        this.setState({ campaigns, rows: campaigns, loading: false, stores });
    }

    async createCampaign(payload) {
        try {
            this.setState({ loading: true });
            const campaign = await this.data.createCampaign(payload);

            if (!campaign.name) this.setState({ loading: false });
            else {
                const campaigns = await this.data.fetchCampaigns();
                this.setState({ campaigns, rows: campaigns, loading: false });
                this.setIsOpen(false);
            }
        } catch (err) {
            console.log(err);
            this.setState({ loading: false });
        }
    }

    async updateCampaign(campaignId, payload) {
        try {
            this.setState({ loading: true });
            const campaign = await this.data.updateCampaign(campaignId, payload);

            if (!campaign._id) this.setState({ loading: false });
            else {
                const campaigns = await this.data.fetchCampaigns();
                this.setState({ campaigns, rows: campaigns, loading: false });
                this.setIsOpen(false);
            }
        } catch (err) {
            console.log(err);
            this.setState({ loading: false });
        }
    }

    openEditDrawer(campaign) {
        this.setState({
            isOpen: true,
            editMode: true,
            editingCampaign: campaign
        });
    }
}

export default CampaignsController;
